const printerStages = [
  { code: 0, label: "Recebido", title: "Recebido pela gráfica" },
  { code: 1, label: "Confirmado", title: "Confirmado pela gráfica" },
  { code: 2, label: "Produção", title: "Em produção" },
  { code: 3, label: "Faturamento", title: "Faturado" },
  { code: 4, label: "Expedição", title: "Em expedição" },
  { code: 5, label: "Coletado", title: "Coletado pela transportadora" },
];
function parsePrinterStatus(value) {
  if (value === null || value === undefined || !/^-?\d+$/.test(String(value))) return null;
  const status = Number(value);
  return [-1, 0, 1, 2, 3, 4, 5, 6].includes(status) ? status : null;
}
function printerStatusInfo(value) {
  const code = parsePrinterStatus(value);
  if (code === -1) return { code, title: "Pendência na gráfica", tone: "error" };
  if (code === 6) return { code, title: "Cancelado na gráfica", tone: "error" };
  const stage = printerStages.find((item) => item.code === code);
  return stage
    ? { ...stage, tone: code === 5 ? "success" : code === 2 ? "active" : "neutral" }
    : { code: null, title: "Aguardando atualização da gráfica", tone: "neutral" };
}
const isPaid = (value) =>
  ["pago", "paid", "aprovado", "approved", "pagamento confirmado", "pagamento aprovado"].includes(
    String(value || "")
      .trim()
      .toLowerCase()
  );
module.exports = { printerStages, parsePrinterStatus, printerStatusInfo, isPaid };
